import { faker } from '@faker-js/faker/locale/ja';
import {
  ApPayeeDetailDisplay,
  ApPayeeDetailDisplayInvoiceReceiveEmailProcessType,
} from 'ap-openapi';
import { HttpResponse, delay, http } from 'msw';
faker.seed(42);
const _getOfficeMembers = Array.from({ length: 11 }, (_, key) => ({
  [key]: Array.from({ length: 25 }, () => {
    const name = faker.person.fullName();
    const id = faker.string.uuid();
    const display_name = `${name}(${id})`;
    return {
      display_name: display_name,
      id: id,
      name: name,
      number: faker.helpers.arrayElement([
        faker.number.int().toString(),
        undefined,
      ]),
    };
  }),
})).reduce((obj, item) => ({ ...obj, ...item }), {});
export const getOfficeMembers = (page: number) => _getOfficeMembers[page] ?? [];

const _getGetApPayees = Array.from({ length: 11 }, (_, key) => ({
  [key]: Array.from({ length: 25 }, () => {
    const name = faker.company.name();
    const code = faker.string.uuid();
    return {
      book_date: faker.date.past().toISOString().split('T')[0],
      code: code,
      default_cr_item_id: faker.word.sample(),
      default_cr_sub_item_id: faker.word.sample(),
      default_dept_id: faker.word.sample(),
      default_ex_item_id: faker.word.sample(),
      default_name: name,
      default_project_code_id: faker.word.sample(),
      display_name: `${name}(${code})`,
      account_display_name: faker.helpers.arrayElement([
        '沖縄銀行 曙町支店 当座 1111111 ﾃｽﾄ',
        undefined,
      ]),
      id: code,
      invoice_registration_number: faker.number
        .int({ min: 1000000000000, max: 9999999999999 })
        .toString(),
      is_tax_included: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      is_withholding_tax: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      name: name,
      payment_method: faker.helpers.arrayElement([
        'bank_transfer',
        'cash',
        'payment_slip',
        'direct_debit',
        'credit_card',
        'prepaid_card',
        'check',
        'promissory_note',
        'densai',
        'remittance_abroad',
        'other',
        undefined,
      ]),
      payment_date: faker.helpers.arrayElement([
        faker.date.past().toISOString().split('T')[0],
        undefined,
      ]),
      priority: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      contact_office_members: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 5 }) },
          (_, i) => i + 1
        ).map(() => {
          const name = faker.company.name();
          const code = faker.string.uuid();
          return {
            display_name: `${name}(${code})`,
            id: code,
            name: name,
          };
        }),
      ]),
    };
  }),
})).reduce((obj, item) => ({ ...obj, ...item }), {});

export const getGetApPayees = (page: number) => _getGetApPayees[page] ?? [];

const getGetApPayeesDetailProperty = (id: string) => {
  const name = faker.company.name();
  const code = faker.string.uuid();

  return {
    id: id,
    code: code,
    name: name,
    display_name: `${name}(${code})`,
    account_display_name: faker.helpers.arrayElement([
      '沖縄銀行 曙町支店 当座 1111111 ﾃｽト',
      undefined,
    ]),
    payment_method: faker.helpers.arrayElement([
      'bank_transfer',
      'cash',
      'payment_slip',
      'direct_debit',
      'credit_card',
      'prepaid_card',
      'check',
      'promissory_note',
      'densai',
      'remittance_abroad',
      'other',
      undefined,
    ]),
    book_date: faker.date.past().toISOString().split('T')[0],
    payment_date: faker.helpers.arrayElement([
      faker.date.past().toISOString().split('T')[0],
      undefined,
    ]),
    default_name: name,
    default_cr_item_id: faker.word.sample(),
    default_cr_sub_item_id: faker.word.sample(),
    default_dept_id: faker.word.sample(),
    default_ex_item_id: faker.word.sample(),
    default_project_code_id: faker.word.sample(),
    invoice_registration_number: faker.number
      .int({ min: 1000000000000, max: 9999999999999 })
      .toString(),
    is_tax_included: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    is_withholding_tax: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    priority: faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      undefined,
    ]),
    contact_office_member_name: faker.person.fullName(),
    contact_office_member_names: Array.from({ length: 3 }, () =>
      faker.person.fullName()
    ).join(', '),
    is_active: true,
    contact_person_email: faker.helpers.arrayElement([faker.internet.email()]),
    contact_person_name: faker.person.fullName(),
    invoice_receive_email_address: faker.internet.email(),
    is_invoice_receive_email_setting: true,
    invoice_receive_email_process_type: faker.helpers.arrayElement(
      Object.values(ApPayeeDetailDisplayInvoiceReceiveEmailProcessType)
    ),
    is_agent_receive_setting: true,
    is_supplier_upload_setting: true,
    agent_receive_setting: {
      address: faker.location.streetAddress(),
      destination: faker.location.streetAddress(),
      unique_code: faker.string.uuid(),
    },
    supplier_upload_setting: {
      expired_at: '2025年3月13日 23:49まで',
      invitation_status: '未登録',
      invitation_url: faker.internet.url(),
      is_accepted_invitation: true,
      is_expired_invitation_url: true,
      is_published_invitation_url: true,
      tenant_name: faker.company.name(),
    },
    contact_office_members: getGetOfficeMembersMock(
      1,
      ''
    ).office_members.splice(0, 2),
  };
};

const getGetApPayeesDetail = (id: string): ApPayeeDetailDisplay => {
  const name = faker.company.name();
  const code = faker.string.uuid();
  const res = {
    id: code,
    display_name: `${name}(${code})`,
    account_display_name: faker.helpers.arrayElement([
      '沖縄銀行 曙町支店 当座 1111111 ﾃｽト',
      undefined,
    ]),
    contact_office_member_name: faker.person.fullName(),
    contact_office_member_names: Array.from({ length: 3 }, () =>
      faker.person.fullName()
    ).join(', '),
    is_active: true,
    contact_person_email: faker.internet.email(),
    contact_person_name: faker.person.fullName(),
    invoice_receive_email_address: faker.internet.email(),
    is_invoice_receive_email_setting: true,
    invoice_receive_email_process_type: faker.helpers.arrayElement(
      Object.values(ApPayeeDetailDisplayInvoiceReceiveEmailProcessType)
    ),
    is_agent_receive_setting: true,
    is_supplier_upload_setting: true,
    agent_receive_setting: {
      address: faker.location.streetAddress(),
      destination: faker.location.streetAddress(),
      unique_code: faker.string.uuid(),
    },
    supplier_upload_setting: {
      expired_at: '2025年3月13日 23:49まで',
      invitation_status: '未登録',
      invitation_url: faker.internet.url(),
      is_accepted_invitation: true,
      is_expired_invitation_url: true,
      is_published_invitation_url: true,
      tenant_name: faker.company.name(),
    },
  };

  switch (id) {
    case 'no_receive_setting': {
      return {
        ...res,
        is_agent_receive_setting: false,
        is_supplier_upload_setting: false,
      };
    }
    case 'no_receive_email_setting': {
      return {
        ...res,
        is_invoice_receive_email_setting: false,
      };
    }
    case 'receive_email_setting_receive_invoice': {
      return {
        ...res,
        invoice_receive_email_process_type: 'received_invoice',
      };
    }
    case 'receive_email_setting_payment_request_with_pic': {
      return {
        ...res,
        invoice_receive_email_process_type: 'payment_request',
      };
    }
    case 'receive_email_setting_payment_request': {
      return {
        ...res,
        contact_office_member_name: undefined,
        invoice_receive_email_process_type: 'payment_request',
      };
    }
    case 'registered_account': {
      return {
        ...res,
        supplier_upload_setting: {
          ...res.supplier_upload_setting,
          invitation_status: '登録済み',
          is_accepted_invitation: true,
        },
      };
    }
    case 'expired_invitation': {
      return {
        ...res,
        supplier_upload_setting: {
          ...res.supplier_upload_setting,
          is_accepted_invitation: false,
          is_expired_invitation_url: true,
        },
      };
    }
    case 'not_published_account_url': {
      return {
        ...res,
        supplier_upload_setting: {
          ...res.supplier_upload_setting,
          is_published_invitation_url: false,
          is_accepted_invitation: false,
        },
      };
    }
    case 'published_account_url': {
      return {
        ...res,
        supplier_upload_setting: {
          ...res.supplier_upload_setting,
          is_accepted_invitation: false,
          is_expired_invitation_url: false,
          is_published_invitation_url: true,
        },
      };
    }
    default: {
      return res;
    }
  }
};

export const getGetApPayeesMock = (page: number, query: string) => ({
  next: page <= 2 ? `/api/js/ap_payees?page=${page + 1}` : undefined,
  ap_payees: getGetApPayees(page - 1).filter((q) =>
    !query ? true : q.display_name.indexOf(query) !== -1
  ),
  prev: page > 1 ? `/api/js/ap_payees?page=${page - 1}` : undefined,
});
const getGetOfficeMembersMock = (page: number, query: string) => ({
  next: page <= 2 ? `/api/js/office_members?page=${page + 1}` : undefined,
  office_members: getOfficeMembers(page - 1).filter((q) =>
    !query ? true : q.display_name.indexOf(query) !== -1
  ),
  prev: page > 1 ? `/api/js/office_members?page=${page - 1}` : undefined,
});

export const getGetApPayeesInfoMock = () => ({
  agent_receive_setting: faker.helpers.arrayElement([
    {
      address: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      destination: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      unique_code: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  ai_agent_service_settings: [
    {
      is_enabled: faker.datatype.boolean(),
      service_type: 'invoice_download_agent' as const,
    },
  ],
  ap_invoice_transaction_default_value: faker.helpers.arrayElement([
    {
      ap_item: faker.helpers.arrayElement([
        {
          display_name: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
        },
        undefined,
      ]),
      default_currency: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      expense_dept: faker.helpers.arrayElement([
        {
          display_name: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
        },
        undefined,
      ]),
      is_tax_included: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      project_code: faker.helpers.arrayElement([
        {
          display_name: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
        },
        undefined,
      ]),
    },
    undefined,
  ]),
  ap_payee_contact_setting: faker.helpers.arrayElement([
    {
      address: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      postal_code: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      prefecture_id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    },
    undefined,
  ]),
  contact_office_member: faker.helpers.arrayElement([
    {
      display_name: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      number: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  contact_office_members: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      display_name: faker.word.sample(),
      id: faker.word.sample(),
      number: faker.word.sample(),
    })),
    undefined,
  ]),
  contact_person_email: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  contact_person_full_address: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  contact_person_name: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  contact_person_phone_number: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  dept_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  display_name: faker.word.sample(),
  id: faker.word.sample(),
  invoice_receive_email_address: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  invoice_receive_email_process_type: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      'payment_request',
      'received_invoice',
    ] as const),
    undefined,
  ]),
  is_active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  is_agent_receive_setting_enabled: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  is_editable: true,
  is_invoice_receive_email_setting_existed: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  is_invoice_receive_mail_address_issued: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  is_supplier_upload_setting_enabled: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  payment_closing_date: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  payment_due_date: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  payment_holiday_rule: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  payment_month: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  supplier_upload_setting: faker.helpers.arrayElement([
    {
      expiration_datetime: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      invitation_status: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      invitation_url: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      is_accepted_invitation: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      is_expired_invitation_url: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      is_published_invitation_url: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      tenant_display_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
});
export const getGetApPayeesDetailMock = (id: string) =>
  getGetApPayeesDetail(id);

export const handlers = [
  http.get('*/api/js/ap_payees', async (req) => {
    await delay(1000);
    const url = new URL(req.request.url, location.href);
    const page = url.searchParams.has('page')
      ? parseInt(url.searchParams.get('page') ?? '1')
      : 1;
    const query = url.searchParams.get('query') ?? '';
    return new HttpResponse(JSON.stringify(getGetApPayeesMock(page, query)), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
  http.get('*/api/js/ap_payees/:id', async (req) => {
    await delay(1000);
    if (typeof req.params.id !== 'string') return;
    return new HttpResponse(
      JSON.stringify(getGetApPayeesDetailProperty(req.params.id)),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
  http.get('*/api/js/office_members', async (req) => {
    await delay(1000);
    const url = new URL(req.request.url, location.href);
    const page = url.searchParams.has('page')
      ? parseInt(url.searchParams.get('page') ?? '1')
      : 1;
    const query = url.searchParams.get('query') ?? '';
    return new HttpResponse(
      JSON.stringify(getGetOfficeMembersMock(page, query)),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
  http.get('*/api/js/ap_payees/:id/detail', async (req) => {
    await delay(1000);
    const id = req.params.id;
    if (id instanceof Array) return;

    return new HttpResponse(JSON.stringify(getGetApPayeesDetailMock(id!)), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
  http.get('*/api/js/ap_payees/:id/info', async () => {
    await delay(1000);
    return new HttpResponse(JSON.stringify(getGetApPayeesInfoMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
  http.patch('*/api/js/ap_payees/:id/info', async () => {
    await delay(1000);

    return new HttpResponse(JSON.stringify(getGetApPayeesInfoMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
];
